const { ALGOLIA_ENV, ALGOLIA_APPLICATION_ID, ALGOLIA_SEARCH_API, APP_ENV } = process.env
export const DEFAULT_APP = '/public/browse'
export const DEFAULT_URL = `/all`
export const DEFAULT_PRINT_URL = `/prints`
export const applicationId: string = ALGOLIA_APPLICATION_ID || ''
export const searchApi: string = ALGOLIA_SEARCH_API || ''
export const SCULPTURE = 'Sculpture'
export const PAINTINGS = 'Paintings'
export const PHOTOGRAPHY = 'Photography'
const algoliaEnv: string = ALGOLIA_ENV || APP_ENV || 'production'
export const searchIndice: string = `${algoliaEnv}_all_artworks`
export const browseSearchIndice: string = `${algoliaEnv}_for_sale_artworks`
export const BROWSE_NEXT_APP_ROUTE = '/public/browse'

export const sortOptions: Array<{ value: string; title: string; indice: string }> = [
  { value: 'default', title: 'Recommended', indice: browseSearchIndice },
  { value: 'newest', title: 'Date Listed: New to Old', indice: `${browseSearchIndice}_newest` },
  { value: 'price-low', title: 'Price: Low to High', indice: `${browseSearchIndice}_price_low` },
  { value: 'price-high', title: 'Price: High to Low', indice: `${browseSearchIndice}_price_high` },
]

export const geoPricingSortZonesList = ['EU2C', 'US', 'AM1A', 'AP2I', 'EU1C']

export const geoPricingSortOptions: Array<{ value: string; title: string; indice: string }> = [
  { value: 'default', title: 'Recommended', indice: browseSearchIndice },
  {
    value: 'newest',
    title: 'Date Listed: New to Old',
    indice: `${browseSearchIndice}_upload_date_desc`,
  },
  { value: 'price-low', title: 'Price: Low to High', indice: `${browseSearchIndice}_price_asc` },
  { value: 'price-high', title: 'Price: High to Low', indice: `${browseSearchIndice}_price_desc` },
]

const replaceSortIndex = (indice: string, hasPrints: boolean): string => {
  return hasPrints ? indice.replace(browseSearchIndice, searchIndice) : indice
}

export const getSortIndice = (
  sort: string,
  destinationZone: string,
  hasPrints: boolean
): string => {
  const sortOption = geoPricingSortOptions.find((option) => option.value === sort)
  const isSortNewestOrDefault = sortOption?.value === 'newest' || sortOption?.value === 'default'
  if (isSortNewestOrDefault) {
    return replaceSortIndex(sortOption.indice, hasPrints)
  }

  const isValidZone = geoPricingSortZonesList.includes(destinationZone) && sortOption?.indice
  const sortIndex = isValidZone ? `${sortOption.indice}_${destinationZone}` : browseSearchIndice
  return replaceSortIndex(sortIndex, hasPrints)
}
export const breadcrumbFacets = [
  'has_prints',
  'category',
  'prints_availability',
  'prints_materials',
  'styles',
  'subject',
  'mediums',
  'country',
  'artist_recognition',
]
export const facetLabelMapping = {
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
  oversized: 'Oversized',
  landscape: 'Horizontal',
  portrait: 'Vertical',
  square: 'Square',
  rag: 'Fine Art Paper',
  photo: 'Photo Paper',
  canvas: 'Canvas',
  default: 'Recommended',
  newest: 'Date Listed: New to Old',
  open: 'Open Editions',
  limited: 'Limited Editions',
  'price-low': 'Price: Low to High',
  'price-high': 'Price: High to Low',
}
export const PRINT_MATERIALS_ATTRIBUTES_LIST = ['rag', 'photo', 'canvas', 'metal', 'acrylic']
export const PRINT_MATERIALS_OVERRIDE_RULES = {
  rag: 'Fine Art Paper',
  canvas: 'Canvas',
  photo: 'Photo Paper',
  acrylic: 'Acrylic',
  metal: 'Metal',
}

export const PRINT_PRICE_ATTRIBUTES_LIST = [
  {
    label: 'Under $200',
    presetMin: 0,
    presetMax: 200,
    format: 'under',
  },
  {
    label: '$200 - $300',
    presetMin: 200,
    presetMax: 300,
    format: 'divider',
  },
  {
    label: '$300 - $400',
    presetMin: 300,
    presetMax: 400,
    format: 'divider',
  },
  {
    label: '$400 - $500',
    presetMin: 400,
    presetMax: 500,
    format: 'divider',
  },
  {
    label: 'Over $500',
    presetMin: 500,
    presetMax: 500000,
    format: 'over',
  },
]
